import { Stack } from '@mui/system';
import { ElementType, ReactNode } from 'react';
import { ConversationMessageContentType } from 'src/@types/conversation';
import { ConversationUploadDropzone } from '../ConversationUploadDropzone';
import { useConvertMediaFile } from '../hooks/useConvertMediaFile';

type Props = {
  children: ReactNode;
  handleFileSelect: (type: ConversationMessageContentType, file: File) => void;
  searchTerm?: string;
  SearchComponent?: ElementType;
};

export const ConversationContainer = ({
  children,
  handleFileSelect,
  searchTerm,
  SearchComponent,
}: Props) => {
  const { checkFileToConvert } = useConvertMediaFile();

  const handleConvertFile = async (
    type: ConversationMessageContentType,
    file: File,
  ) => {
    const mediaFile = await checkFileToConvert(type, file);
    handleFileSelect(type, mediaFile);
  };

  return (
    <Stack flexGrow={1} position="relative" overflow="hidden">
      <ConversationUploadDropzone
        sx={{
          flexGrow: 1,
          overflow: 'hidden',
        }}
        onDrop={handleConvertFile}
      >
        {/* Insert here the MessageListContainer with the messageList as children and the input component */}
        {children}
      </ConversationUploadDropzone>
      {searchTerm && SearchComponent && <SearchComponent />}
    </Stack>
  );
};
